import React from 'react'
import Button from 'material-ui/Button'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

const Paginator = ({ onNext, onPrev, isPrevDisabled, isNextDisabled }) =>
  <div>
    <Button title='Previous' onClick={onPrev} disabled={isPrevDisabled}>
      <ChevronLeftIcon />
    </Button>
    <Button title='Next' onClick={onNext} disabled={isNextDisabled}>
      <ChevronRightIcon />
    </Button>
  </div>

export default Paginator



// WEBPACK FOOTER //
// ./src/jobs/Paginator.js